module.exports = __webpack_public_path__ + "img/bg.8d20f47d.png";